import { Modal } from "antd-mobile";
import styled from "styled-components";
import { Grid } from "antd-mobile";
import Image from "../../../../components/Image";
import FeatureProcesses from "../../../../components/FeatureProcesses";
import { useIntl } from "react-intl";
import Attributes from "../../../../components/Attributes";
// 装备详情
export default function useEquipModal() {
  const intl = useIntl();
  const show = ({ onConfrim = () => {}, equip = {}, isMounted }) => {
    const mount_text = intl.formatMessage({
      id: "components.equip_modal.mount",
      defaultMessage: "去裝備",
    });
    const unmount_text = intl.formatMessage({
      id: "components.equip_modal.unmount",
      defaultMessage: "卸下",
    });
    const tranfer_text = intl.formatMessage({
      id: "components.equip_modal.tranfer",
      defaultMessage: "轉讓",
    });

    const cancel_text = intl.formatMessage({
      id: "common.cancel",
      defaultMessage: "取消",
    });

     
    return Modal.show({
      // title: "#" + equip.id,
      bodyClassName: "runbit_modal",
      showCloseButton: true,
      actions: [
        {
          key: "1",
          className: "border_btn",
          text: equip.equip.remain_durability ? (isMounted ? unmount_text : mount_text):cancel_text,
        },{
          key: "2",
          className: "primary_btn",
          text: tranfer_text,
          primary: true,
        },
      ],
      onAction: (action, index) => {
        console.log("onConfrim");
        onConfrim(action);
      },
      closeOnAction: false,
      content: <EquipModal equip={equip} isMounted={isMounted} intl={intl} />,
    });
  };
  return {
    show,
  };
}

function EquipModal({ equip, isMounted, intl }) {
  return (
    <div className="text-center" style={{ paddingTop: "1.0rem" }}>
      <EquipName>
        <span>
          {new Array(equip.level || 0).fill("").map((e, i) => (
            <img key={i} src="/image/foot.png" width={8} alt="foot" />
          ))}{" "}
          {equip.name || "Level"}
        </span>
      </EquipName>
      <div style={{
                display: "inline-block",
                height: "12.0rem",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
      <Image
        width={"17.0rem"}
        fit="contain"
        style={{ margin: "auto", minHeight: "17.0rem" , marginTop: '-1.5rem'}}
        src={equip.goodImg || equip.img || "/image/question_mark.png"}
        alt={"equips_img"}
      ></Image>
      </div>
      {equip.id ? (
        <div className="text-center">
          <Code>
            <I src="/image/codeIndex.png" />
            {equip.id}
          </Code>
        </div>
      ) : null}
      <Attributes equip={equip.equip} intlfn={intl}/>
      <FeatureProcesses
      intlfn={intl}
        specialty={equip.equip ? equip.equip.specialty : 0}
        aesthetic={equip.equip ? equip.equip.aesthetic : 0}
        comfort={equip.equip ? equip.equip.comfort : 0}
        resilence={equip.equip ? equip.equip.resilence : 0}
      />

      <Tip>
        {isMounted
          ? intl.formatMessage({
              id: "components.equip_modal.mounted",
              defaultMessage: "已裝備",
            })
          : intl.formatMessage({
              id: "components.equip_modal.unmounted",
              defaultMessage: "未裝備",
            })}
      </Tip>
    </div>
  );
}

const Processes2 = styled.div`
  background: #cccccc;
  border: 1px solid #344362;
  border-radius: 1.5rem;
  height: 1.8rem;
  overflow: hidden;
  .inner {
    height: 100%;
    width: 40%;
    background: url(image/icons/icon22.png) repeat-x;
    background-size: 3.0rem 100%;
    background-position: right top;
    background-color: #5acdc3;
    border-radius: 1.5rem;
  }
`;

const T = styled.div`
  font-weight: 400;
  font-size: 1.3rem;
  line-height: 1.4rem;
  text-align: left;
  margin-bottom: 1.0rem;
  margin-top: 2.0rem;
  color: #000000;
`;

const Tip = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 1.4rem;

  color: #969696;
  margin-top: 2.0rem;
  strong {
    color: #000;
  }
`;

const EquipName = styled.div`
  background: #f4f5f6;
  border-radius: .0rem .0rem 1.3rem 1.3rem;
  text-align: center;
  width: 14.6rem;
  margin: auto;
  padding: .5rem 0 .8rem;
  font-style: normal;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.5rem;
  position: absolute;
  color: #000000;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
`;


const Code = styled.div`
  font-family: "Anybody";
  font-style: italic;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.2rem;
  color: ${(props) => (props.mounted ? "#FC9043" : "#000000")};
  border: 1px solid ${(props) => (props.mounted ? "#FC9043" : "#000000")};
  border-radius: 1.9rem;
  min-width: 10.0rem;
  padding: 2px 1px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 1.0rem auto 0;
  box-shadow: .05rem .05rem .0rem
    ${(props) => (props.mounted ? "#FC9043" : "#000000")};
`;

const I = styled.img`
  width: 1.4rem;
  height: 1.4rem;
  margin-right: .8rem;
`;

const Processes = styled.div`
  padding: 0 .0rem;
  margin-top: 2.0rem;
  .processWrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .l {
    display: flex;
    align-items: center;
    margin-bottom: .7rem;
    flex: 1;
  }
  .t {
    font-style: normal;
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 1.4rem;
    color: #000000;
    display: inline-block;
    padding: 0 .5rem 0 1.0rem;
    width: 4.0rem;
    text-align: left;
  }
  .v {
    font-style: normal;
    font-weight: 500;
    font-size: 1.3rem;
    line-height: 1.3rem;

    color: #000000;
  }
  .process {
    flex: 1;
    align-self: stretch;

    .processInner {
      background: #ccd8db;
      border: .05rem solid #344362;
      border-radius: 1.0rem;
      height: 70%;
      width: 50%;
      margin-top: 2%;
    }
  }
`;
